import api from './api';
import { Filter } from './dashboardContratos';

export interface DashboardMedicaoData {
  statusBMFromAPI: DataResult[];
  statusDocumentacaoAcessoriaMensalFromAPI: DataResult[];
  statusAutorizacaoPagamentoFromAPI: DataResult[];
  statusAutorizacaoMatchingFromAPI: DataResult[];

  statusBM: GraficoInfo[];
  statusDocumentacaoAcessoriaMensal: GraficoInfo[];
  statusAutorizacaoPagamento: GraficoInfo[];
  statusAutorizacaoMatching: GraficoInfo[];
  gerirDocumentacaoAcessoria: boolean;

  statusBoletimMedicao: InformacaoContrato[];
  statusAutorizacaoPagamentoContrato: InformacaoContrato[];
  statusMatching: InformacaoContrato[];
}

export interface DataResult {
  nome?: String;
  codigo: number;
  valor: number;
}

export interface InformacaoContrato {
  numero: number;
  numeroBoletim: number;
  fornecedor: string;
  dataInicio: Date;
  dataFim: Date;
  dataInicioFormatada: string;
  dataFimFormatada: string;
  idTemporario: string;
}

export interface GraficoInfo {
  name?: String;
  visible?: boolean;
  data?: Object;
}

export const getDashboardMedicaoData = (values: Filter = {}) => {
  return api
    .post<DashboardMedicaoData>('contratos/dashboardMedicao', values, {
      disableNotification: 'true',
    })
    .then(resp => {
      const data: DashboardMedicaoData = {} as DashboardMedicaoData;
      data.statusBM = resp.statusBMFromAPI.map((a: DataResult, i) => {
        return {
          name: a.nome,
          visible: ![7, 8].includes(a.codigo),
          data: [{ x: i, y: a.valor }],
        };
      });

      data.statusDocumentacaoAcessoriaMensal = resp.statusDocumentacaoAcessoriaMensalFromAPI
        ? resp.statusDocumentacaoAcessoriaMensalFromAPI.map((a: DataResult, i) => {
          return {
            name: a.nome,
            visible: a.codigo != 3,
            data: [{ x: i, y: a.valor }],
          };
        })
        : [];

      data.statusAutorizacaoPagamento = resp.statusAutorizacaoPagamentoFromAPI
        ? resp.statusAutorizacaoPagamentoFromAPI.map((a: DataResult, i) => {
          return {
            name: a.nome,
            visible: a.codigo != 5,
            data: [{ x: i, y: a.valor }],
          };
        })
        : [];

      data.statusAutorizacaoMatching = resp.statusAutorizacaoMatchingFromAPI
        ? resp.statusAutorizacaoMatchingFromAPI.map((a: DataResult, i) => {
          return {
            name: a.nome,
            visible: a.codigo != 6,
            data: [{ x: i, y: a.valor }],
          };
        })
        : [];

      data.gerirDocumentacaoAcessoria = resp.gerirDocumentacaoAcessoria;
      data.statusBoletimMedicao = resp.statusBoletimMedicao;
      data.statusAutorizacaoPagamentoContrato = resp.statusAutorizacaoPagamentoContrato;
      data.statusMatching = resp.statusMatching;
      return data;
    });
};